// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__2V8cT","widget":"styles_widget__1r4CZ","label":"styles_label__1L7vq"};